import React from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import axios from "axios";
import { API } from "../../lib/api";

export default function BusinessSetPasswordPage() {
  // Used for both invite (?t=) and password reset (?t=)
  const nav = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("t") || "";
  const [pw, setPw] = React.useState("");
  const [pw2, setPw2] = React.useState("");
  const [busy, setBusy] = React.useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { toast.error("Mindst 8 tegn"); return; }
    if (pw !== pw2) { toast.error("Kodeordene matcher ikke"); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/business/auth/reset`, { token, new_password: pw });
      toast.success("Kodeord oprettet — log venligst ind");
      nav("/business/login", { replace: true });
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Kunne ikke sætte kodeord");
    } finally { setBusy(false); }
  };

  if (!token) {
    return <div className="min-h-screen flex items-center justify-center text-brand-text2">Manglende token. Tjek dit invite-link.</div>;
  }

  return (
    <div className="min-h-screen bg-brand-bg2 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <h1 className="font-display font-bold text-2xl text-brand-dark text-center mb-4">Vælg dit kodeord</h1>
        <form onSubmit={onSubmit} className="bg-white border border-brand p-6 space-y-4" data-testid="business-set-password-form">
          <div>
            <label className="label-flat">Nyt kodeord (min. 8 tegn)</label>
            <input className="input-flat" type="password" required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} data-testid="business-set-pw"/>
          </div>
          <div>
            <label className="label-flat">Gentag</label>
            <input className="input-flat" type="password" required minLength={8} value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="business-set-pw2"/>
          </div>
          <button type="submit" disabled={busy} className="btn-primary w-full justify-center" data-testid="business-set-pw-submit">
            {busy ? <Loader2 className="animate-spin" size={16}/> : "Gem kodeord"}
          </button>
          <div className="text-center text-sm">
            <Link to="/business/login" className="text-brand-text2 underline">Tilbage til login</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
